import { Tooltip } from '@alefeducation/ui-elements-library-core';
import { Info } from '@alefeducation/ui-elements-library-icons';

interface Props {
  id: string;
  text: string;
}

const InfoTooltip = ({ id, text }: Props) => {
  return (
    <Tooltip
      content={text}
      data-testid="info-tooltip"
      delayHide={0}
      delayShow={0}
      id={`info-tooltip-${id}`}
      position="bottom"
    >
      <Info width={12} height={12} />
    </Tooltip>
  );
};

export default InfoTooltip;
